export default class Reset extends CustomEvent {
    constructor(caller) {
        super('reset', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
